import React from "react";
import Carousels from "../components/schoolspage/Carousels";
import Details from "../components/schoolspage/Details";
import MemebersProgram from "../components/schoolspage/MembersProgram";

function School() {
  return (
    <div className="schools">
      <Carousels />
      <Details />
      <MemebersProgram />
    </div>
  );
}

export default School;
